import React, { useEffect, useState } from 'react';
import ToastContainer from './ToastContainer';
import ToastService from './ToastService';
import { ToastMessage } from './Toast';

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  useEffect(() => {
    // 订阅 Toast 服务
    const unsubscribe = ToastService.subscribe(setMessages);
    return unsubscribe;
  }, []);

  const handleRemove = (id: string) => {
    ToastService.remove(id);
  };

  return (
    <>
      {children}
      <ToastContainer messages={messages} onRemove={handleRemove} />
    </>
  );
};

export default ToastProvider;